import React, {useState} from 'react';
import {Line, LineChart, ResponsiveContainer, CartesianGrid, Tooltip, Legend, Label, XAxis, YAxis} from 'recharts';

const colors = ['#332288', '#88CCEE', '#44AA99', '#117733', '#999933', '#DDCC77', '#CC6677', '#882255', '#AA4499', '#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'pink'];

export default function LineGraph({title, data, xDataKey = 'label', yDataKey = 'value', tooltipFormatter = null, onClick = null}) {
    return (
        <div className="card chart-container">
            <h5 className="chart-title">{title}</h5>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3"/>
                    <XAxis dataKey={xDataKey} type="category" allowDuplicatedCategory={false} />
                    <YAxis
                        dataKey={yDataKey}
                        label={{
                            value: 'Days',
                            angle: -90,
                            position: 'insideLeft'
                        }}
                    />
                    <Tooltip/>
                    <Legend />
                    {data.map((s, i) => (
                        <Line dataKey="value" data={s.data} name={s.name} key={s.name} stroke={colors[i]} />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}